import {
  DOCUMENT_TEMPLATE_GET_LIST,
  DOCUMENT_TEMPLATE_SEND_SIGNING,
  DOCUMENT_TEMPLATE_GET,
  DOCUMENT_TEMPLATE_UPDATE,
  DOCUMENT_TEMPLATE_CREATE,
  DOCUMENT_TEMPLATE_SET_TEMP,
  DOCUMENT_TEMPLATE_REQUEST,
  DOCUMENT_TEMPLATE_SUCCESS,
  DOCUMENT_TEMPLATE_ERROR
} from "@/store/types"

import axios from "@/store/axios"
// import _ from "lodash"

const state = {
  current: null,
  templates: null,
  temp: null,
  isLoading: false,
  page: 1,
  totalCount: 0,
  error: null
}

const getters = {
  getDocumentTemplates: (state) => state.templates,
  getCurrentDocumentTemplate: (state) => state.current,
  getDocumentTemplatesCurrentPage: (state) => state.page,
  getDocumentTemplatesTotalCount: (state) => state.totalCount,
  getDocumentTemplateTemp: (state) => state.temp,
  getDocumentTemplateTempFiles: (state) => (state.temp ? state.temp.files : null),
  isDocumentTemplateLoading: (state) => state.isLoading,
  getDocumentTemplateError: (state) => state.error
}

const actions = {
  [DOCUMENT_TEMPLATE_GET]: ({ commit }, { id } = {}) => {
    return new Promise((resolve, reject) => {
      commit(DOCUMENT_TEMPLATE_REQUEST)

      axios
        .get(`/api/v3/document_templates/${id}/`)
        .then((resp) => {
          if (process.env.NODE_ENV === "development") {
            console.log(resp)
          }

          commit(DOCUMENT_TEMPLATE_SUCCESS, { current: resp.data })
          resolve(resp)
        })
        .catch((err) => {
          if (process.env.NODE_ENV === "development") {
            console.log(err)
          }
          commit(DOCUMENT_TEMPLATE_ERROR, err)
          reject(err)
        })
    })
  },
  [DOCUMENT_TEMPLATE_UPDATE]: ({ commit, state }, { id, overlay, name, linkedForm } = {}) => {
    return new Promise((resolve, reject) => {
      commit(DOCUMENT_TEMPLATE_REQUEST)

      const payload = {
        overlay,
        linked_form: linkedForm
      }

      if (name && state.current.name !== name) {
        payload["name"] = name
      }

      axios
        .patch(`/api/v3/document_templates/${id}/`, payload)
        .then((resp) => {
          if (process.env.NODE_ENV === "development") {
            console.log(resp)
          }

          commit(DOCUMENT_TEMPLATE_SUCCESS, { current: resp.data })
          resolve(resp)
        })
        .catch((err) => {
          if (process.env.NODE_ENV === "development") {
            console.log(err)
          }
          commit(DOCUMENT_TEMPLATE_ERROR, err)
          reject(err)
        })
    })
  },
  [DOCUMENT_TEMPLATE_CREATE]: ({ commit, state }, { overlay, linkedForm }) => {
    return new Promise((resolve, reject) => {
      commit(DOCUMENT_TEMPLATE_REQUEST)

      const formData = new FormData()
      const formattedData = {
        name: state.temp.name,
        description: state.temp.description,
        overlay,
        attachment_order: [],
        linked_form: linkedForm
      }

      state.temp.files.forEach((file) => {
        formattedData.attachment_order.push(file.name)
        formData.append(file.name, file)
      })

      formData.append("template_data", JSON.stringify(formattedData))

      axios
        .post(`/api/v3/document_templates/`, formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then((resp) => {
          if (process.env.NODE_ENV === "development") {
            console.log(resp)
          }

          commit(DOCUMENT_TEMPLATE_SUCCESS)
          resolve(resp)
        })
        .catch((err) => {
          if (process.env.NODE_ENV === "development") {
            console.log(err)
          }
          commit(DOCUMENT_TEMPLATE_ERROR, err)
          reject(err)
        })
    })
  },
  [DOCUMENT_TEMPLATE_GET_LIST]: ({ commit }, { page = 1 }) => {
    return new Promise((resolve, reject) => {
      commit(DOCUMENT_TEMPLATE_REQUEST)

      axios
        .get(`/api/v3/document_templates/?page=${page}`)
        .then((resp) => {
          if (process.env.NODE_ENV === "development") {
            console.log(resp)
          }

          resp.data.page = page
          commit(DOCUMENT_TEMPLATE_SUCCESS, {
            templates: resp.data
          })
          resolve(resp)
        })
        .catch((err) => {
          if (process.env.NODE_ENV === "development") {
            console.log(err)
          }
          commit(DOCUMENT_TEMPLATE_ERROR, err)
          reject(err)
        })
    })
  },
  [DOCUMENT_TEMPLATE_SEND_SIGNING]: (
    { commit },
    { id, sentTo, subject, customMessage, selectedBundle }
  ) => {
    return new Promise((resolve, reject) => {
      // commit(DOCUMENT_TEMPLATE_REQUEST)

      axios
        .post(`/api/v3/document_templates/${id}/send_signing/`, {
          sent_to: sentTo,
          subject,
          custom_message: customMessage,
          bundle: selectedBundle ? selectedBundle.slug : null
        })
        .then((resp) => {
          if (process.env.NODE_ENV === "development") {
            console.log(resp)
          }
          commit(DOCUMENT_TEMPLATE_SUCCESS)
          resolve(resp)
        })
        .catch((err) => {
          if (process.env.NODE_ENV === "development") {
            console.log(err)
          }
          commit(DOCUMENT_TEMPLATE_ERROR, err)
          reject(err)
        })
    })
  }
}

const mutations = {
  [DOCUMENT_TEMPLATE_SET_TEMP]: (state, temp) => {
    state.temp = temp
  },
  [DOCUMENT_TEMPLATE_REQUEST]: (state) => {
    state.isLoading = true
  },
  [DOCUMENT_TEMPLATE_SUCCESS]: (state, { templates, current } = {}) => {
    state.isLoading = false

    if (current) {
      state.current = current
    }

    if (templates) {
      state.templates = templates.results
      state.page = templates.page
      state.totalCount = templates.count
    }
    state.error = null
  },
  [DOCUMENT_TEMPLATE_ERROR]: (state, err) => {
    state.isLoading = false

    state.error = err
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
